/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface UploadsControllerGetContentV1$Params {
  id: string;
  disposition?: 'inline' | 'attachment';
}

export function uploadsControllerGetContentV1(http: HttpClient, rootUrl: string, params: UploadsControllerGetContentV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, uploadsControllerGetContentV1.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('disposition', params.disposition, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/octet-stream', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

uploadsControllerGetContentV1.PATH = '/v1/uploads/{id}/inhalt';
